
import React, { useEffect, useState } from 'react'; // React is now imported
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  IconButton,
  Grid,
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import axios from 'axios';
import { CONFIG } from '../config'
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';

const RiskRegisterForm = ({ setRegisterFormData, hierarchyData, selectedHie, editSectionId, selectedRiskEvaluateTitle, allEntityData, registerDetailId, allRegister, riskRegisterFormClose, handleCloseRisk, getAllRegister, globalCentreId, globalUserId, selectedRegisteredId, registerName }) => {

  console.log(editSectionId);
  console.log(hierarchyData);



  const generateSixDigitCode = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const uniqueEntityNames = Array.from(
    new Set(allEntityData.map((data) => data.entityName))
  ).filter((name) => name !== "superadmin");

  const [formData, setFormData] = useState({
    riskReference: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.generalInformation.riskReference : (hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.riskHierarchy.key + "-" + generateSixDigitCode() || generateSixDigitCode()),
    riskCategory: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.generalInformation.riskCategory : selectedRiskEvaluateTitle,
    objectivesAffected: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.generalInformation.objectivesAffected : hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.description || '',
    likelihood: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.assessment.likelihood : hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.likelihood || '',
    impact: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.assessment.impact : hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.impact || '',
    riskAppetite: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.assessment.riskAppetite : hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.riskAppetite || '',
    currentControls: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.currentControls.currentControls : "",
    controlEffectiveness: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.currentControls.controlEffectiveness : "",
    mitigation: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.mitigationActions.mitigation : hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.mitigation || '',
    actionOwner: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.mitigationActions.actionOwner : "",
    targetCompletionDate: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.mitigationActions.targetCompletionDate : "",
    status: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.mitigationActions.status : "",
    reviewFrequency: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.reviewFrequency : "",
    lastReviewDate: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.lastReviewDate : "",
    nextReviewDate: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.nextReviewDate : "",
    KRIs: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.kris.map((data) => data.keyIndicator) : [],
    supportingDocumentation: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.supportingDocumentation.map((data) => data.supportingDocument) : [],
    revisionHistory: hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.auditTrail : [],
  });

  console.log(hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.monitoringAndReview.supportingDocumentation.map((data) => data.supportingDocument) : []);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "likelihood" || name === "impact") {
      const likelihood = name === "likelihood" ? parseInt(value) || 0 : formData.likelihood;
      const impact = name === "impact" ? parseInt(value) || 0 : formData.impact;
      setFormData({ ...formData, riskLevel: likelihood * impact, [name]: value });
    }
  };

  const handleAddKRI = () => {
    setFormData({ ...formData, KRIs: [...formData.KRIs, ""] });
  };

  const handleRemoveKRI = (index) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.filter((_, i) => i !== index),
    });
  };

  const handleKRIChange = (index, value) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.map((item, i) => (i === index ? value : item)),
    });
  };

  const handleAddRevision = () => {
    setFormData({
      ...formData,
      revisionHistory: [
        ...formData.revisionHistory,
        { revisionDate: "", revisedBy: "", changesMade: "" },
      ],
    });
  };

  const handleRemoveRevision = (index) => {
    setFormData({
      ...formData,
      revisionHistory: formData.revisionHistory.filter((_, i) => i !== index),
    });
  };

  const handleRevisionChange = (index, field, value) => {
    const updatedHistory = [...formData.revisionHistory];
    updatedHistory[index][field] = value;
    setFormData({ ...formData, revisionHistory: updatedHistory });
  };


  const handleSave = async () => {
    console.log(formData.supportingDocumentation);

    try {
      const existingUrls = formData.supportingDocumentation.filter((item) => typeof item === "string");
      const filesToUpload = formData.supportingDocumentation.filter((item) => item instanceof File);


      const uploadedFileUrls = await Promise.all(
        filesToUpload.map((file) => {
          const uploadFormData = new FormData();
          uploadFormData.append("file", file);
          uploadFormData.append("centreId", "superadmin");

          return fetch(CONFIG.MAIN_URL + "/image/upload", {
            method: "POST",
            body: uploadFormData,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Failed to upload file: ${file.name}`);
              }
              return response.json();
            })
            .then((data) => data.location);
        })
      );


      const allSupportingDocs = [...existingUrls, ...uploadedFileUrls.filter(Boolean)];

      const transformedData = {
        riskAdditionalData: {
          generalInformation: {
            riskReference: formData.riskReference,
            riskCategory: formData.riskCategory,
            objectivesAffected: formData.objectivesAffected,
          },
          assessment: {
            likelihood: formData.likelihood,
            impact: formData.impact,
            riskLevel: formData.likelihood * formData.impact,
            riskAppetite: formData.riskAppetite,
          },
          currentControls: {
            currentControls: formData.currentControls,
            controlEffectiveness: formData.controlEffectiveness,
          },
          mitigationActions: {
            mitigation: formData.mitigation,
            actionOwner: formData.actionOwner,
            targetCompletionDate: formData.targetCompletionDate,
            status: formData.status,
          },
          monitoringAndReview: {
            reviewFrequency: formData.reviewFrequency,
            lastReviewDate: formData.lastReviewDate,
            nextReviewDate: formData.nextReviewDate,
            kris: formData.KRIs.map((kri) => ({ keyIndicator: kri })),
            supportingDocumentation: allSupportingDocs.map((url) => ({
              supportingDocument: url,
            })),
          },
          auditTrail: formData.revisionHistory.map((revision) => ({
            revisionDate: revision.revisionDate,
            revisedBy: revision.revisedBy,
            changesMade: revision.changesMade,
          })),
        },
      };

      setRegisterFormData(transformedData);
      console.log(transformedData);

      hierarchyData = hierarchyData.map((item) => {
        if (item.hierarchyTmpId === selectedHie) {
          return {
            ...item,
            riskHierarchy: {
              ...item.riskHierarchy,
              ...transformedData,
            },
          };
        }
        return item;
      });

      console.log("Updated Hierarchy Data:", hierarchyData);
      console.log(registerDetailId);

      const selectedRegisterIdd = registerDetailId ? registerDetailId : selectedRegisteredId;
      const selectedRegister = allRegister.find((item) => item.id === selectedRegisterIdd);
      selectedRegister.riskRegister.map((item) => {
        if (item.id === editSectionId) {
          item["risks"] = hierarchyData;
        }
      });

      let sendJson = JSON.stringify(selectedRegister);
      console.log(sendJson);


      axios(`${CONFIG.MAIN_URL}/register/save`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        data: sendJson,
      })
        .then((response) => {
          console.log(JSON.stringify(response.data));
          alert("Register updated successfully.");
          // riskRegisterFormClose();
          // handleCloseRisk();
          // getAllRegister(globalCentreId, globalUserId);
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
          alert(`Error saving Register: ${error}`);
        });

      console.log("Data saved successfully!");
    } catch (error) {
      console.error("Error while saving data:", error);
    }
  };

  const CustomTextField = styled(TextField)({
    '& .MuiInputBase-root': {
      fontSize: '9px',
      height: '25px',
      backgroundColor: 'white',
      borderRadius: '0px',
      fontWeight: 'bold',
      padding: '0px',
    },
  });


  


  return (
    <Box sx={{  marginTop: "-17px" }}>
      {/* <Typography variant="h4" gutterBottom>
        Risk Additional Information
      </Typography> */}
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Stack direction="row" spacing={2}
            justifyContent="flex-start">
            <div style={{ fontWeight: "bold", color: 'black' }}>
              {hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null).riskHierarchy.riskAdditionalData.generalInformation.riskReference : (hierarchyData.find((item) => item.hierarchyTmpId === selectedHie)?.riskHierarchy.key)} - {registerName}<br></br>
              {hierarchyData.find(data => data.hierarchyTmpId === selectedHie).name || ""}
            </div>

          </Stack>
        </Grid>

        
        <Grid item xs={12} sm={12} md={6}
           
        >
          <Card
            style={{
              width: "100%",
              backgroundColor: "#f8d7da",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#d9534f",
                      borderRadius: "3px",
                      textAlign: 'center',
                     
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}
                    sx={{ fontSize: { xs: '3px', sm: '3px', md: '20px' }, color: '#2a3f54' }}
                    >General Information</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Reference</Grid>
                <Grid item xs={8}>
<Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                                <div>
                                  <CustomTextField
                                    id="riskReference"
                                    //label="Ownership Role"
                                    size='small'
                                    value={formData.riskReference}
                                    onChange={handleInputChange}
                                  />
                                </div>
                              </Box>

{/** 
                  <input
                    type="text"
                    id="riskReference"
                    name="riskReference"
                    value={formData.riskReference}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                  */}
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Category</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                  <CustomTextField
                    //type="text"
                    id="riskCategory"
                    name="riskCategory"
                    value={formData.riskCategory}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Objectives Affected</Grid>
                <Grid item xs={8}>

                  <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                  <CustomTextField
                    id="objectivesAffected"
                    name="objectivesAffected"
                    value={formData.objectivesAffected}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#fff3cd",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#f0ad4e",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Risk Assessment</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Likelihood</Grid>
                <Grid item xs={8}>
                  <select
                    id="likelihood"
                    name="likelihood"
                    value={formData.likelihood}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5].map((val) => (
                      <>
                        {formData.likelihood === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}

                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Impact</Grid>
                <Grid item xs={8}>
                  <select
                    id="impact"
                    name="impact"
                    value={formData.impact}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5].map((val) => (
                      <>
                        {formData.impact === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Appetite</Grid>
                <Grid item xs={8}>
                  <select
                    id="riskAppetite"
                    name="riskAppetite"
                    value={formData.riskAppetite}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => (
                      <>
                        {formData.riskAppetite === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Level</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="riskLevel"
                    name="riskLevel"
                    value={formData.likelihood * formData.impact}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d4edda",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5cb85c",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Current Controls</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Current Controls</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    //type="text"
                    id="currentControls"
                    name="currentControls"
                    value={formData.currentControls}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>

                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Control Effectiveness</Grid>
                <Grid item xs={8}>
                  <select
                    type="text"
                    id="controlEffectiveness"
                    name="controlEffectiveness"
                    value={formData.controlEffectiveness}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.controlEffectiveness === 'Highly Effective' ?
                      <option value="Highly Effective" selected>Highly Effective</option>
                      :
                      <option value="Highly Effective">Highly Effective</option>
                    }
                    {formData.controlEffectiveness === 'Moderately Effective' ?
                      <option value="Moderately Effective" selected>Moderately Effective</option>
                      :
                      <option value="Moderately Effective">Moderately Effective</option>
                    }
                    {formData.controlEffectiveness === 'Needs Improvement' ?
                      <option value="Needs Improvement" selected>Needs Improvement</option>
                      :
                      <option value="Needs Improvement">Needs Improvement</option>
                    }
                  </select>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d1ecf1",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
               <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5bc0de",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Mitigation Actions</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Mitigation Actions</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="text"
                    id="mitigation"
                    name="mitigation"
                    value={formData.mitigation}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Action Owner</Grid>
                <Grid item xs={8}>
                  <select
                    type="text"
                    id="actionOwner"
                    name="actionOwner"
                    value={formData.actionOwner}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {uniqueEntityNames.map((entityName) => (
                      <>
                        {formData.actionOwner === entityName ?
                          <option key={entityName} value={entityName} selected>{entityName}</option>
                          :
                          <option key={entityName} value={entityName}>{entityName}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Target Completion Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="targetCompletionDate"
                    name="targetCompletionDate"
                    value={formData.targetCompletionDate ? formatDate(formData.targetCompletionDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Status</Grid>
                <Grid item xs={8}>
                  <select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.status === 'Not Started' ?
                      <option value="Not Started" selected>Not Started</option>
                      :
                      <option value="Not Started">Not Started</option>
                    }
                    {formData.status === 'In Progress' ?
                      <option value="In Progress" selected>In Progress</option>
                      :
                      <option value="In Progress">In Progress</option>
                    }
                    {formData.status === 'Completed' ?
                      <option value="Completed" selected>Completed</option>
                      :
                      <option value="Completed">Completed</option>
                    }
                  </select>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#e2e3e5",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#6c757d",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Monitoring & Review</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Review Frequency</Grid>
                <Grid item xs={8}>
                  <select
                    id="reviewFrequency"
                    name="reviewFrequency"
                    value={formData.reviewFrequency}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.reviewFrequency === 'Quarterly' ?
                      <option value="Quarterly" selected>Quarterly</option>
                      :
                      <option value="Quarterly">Quarterly</option>
                    }
                    {formData.reviewFrequency === 'Semi-Annually' ?
                      <option value="Semi-Annually" selected>Semi-Annually</option>
                      :
                      <option value="Semi-Annually">Semi-Annually</option>
                    }
                    {formData.reviewFrequency === 'Annually' ?
                      <option value="Annually" selected>Annually</option>
                      :
                      <option value="Annually">Annually</option>
                    }
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Last Review Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="lastReviewDate"
                    name="lastReviewDate"
                    value={formData.lastReviewDate ? formatDate(formData.lastReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Next Review Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="nextReviewDate"
                    name="nextReviewDate"
                    value={formData.nextReviewDate ? formatDate(formData.nextReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={12} style={{ fontSize: '9px', color: '#2a3f54' }}>KRIs (Key Risk Indicators)</Grid>
                {formData.KRIs.map((kri, index) => (
                  <>
                    <Grid item xs={11} style={{ marginTop: index > 0 ? '-10px' : '' }}>

                      <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                  <CustomTextField
                        //type="text"
                        value={kri}
                        onChange={(e) => handleKRIChange(index, e.target.value)}
                        style={{ fontSize: '9px', height: '12px' }}
                      />
                      </Box>
                    </Grid>
                    <Grid item xs={1} style={{ marginTop: index > 0 ? '-15px' : '-5px' }}>
                      <IconButton onClick={() => handleRemoveKRI(index)} color="error">
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Grid>

                  </>
                ))}
                <Grid item xs={12} style={{ marginTop: '-10px' }}>
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleAddKRI}

                  >
                    Add KRI
                  </Button>
                </Grid>
                <Grid item xs={12} style={{ fontSize: '9px', color: '#2a3f54' }}>Supporting Documentation</Grid>
                <Grid item xs={12}>
                  {formData.supportingDocumentation.map((doc, index) => (
                    <Stack direction="row" spacing={2} alignItems="center" key={index}>
                      <Box sx={{ flexGrow: 1 }}>
                        {typeof doc === 'string' ? (
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            <a href={doc} target="_blank" rel="noopener noreferrer">
                              {doc.split('/').pop()}
                            </a>
                          </Typography>
                        ) : (
                          <>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.png"
                              onChange={(e) => {
                                const uploadedFile = e.target.files[0];
                                setFormData({
                                  ...formData,
                                  supportingDocumentation: formData.supportingDocumentation.map(
                                    (item, i) => (i === index ? uploadedFile : item)
                                  ),
                                });
                              }}
                            />
                            {doc && (
                              <Typography variant="body2" sx={{ mt: 1 }}>
                                {doc.name}
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>
                      <IconButton
                        onClick={() =>
                          setFormData({
                            ...formData,
                            supportingDocumentation: formData.supportingDocumentation.filter(
                              (_, i) => i !== index
                            ),
                          })
                        }
                        color="error"
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Stack>
                  ))}
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() =>
                      setFormData({
                        ...formData,
                        supportingDocumentation: [...formData.supportingDocumentation, null],
                      })
                    }
                    sx={{ mt: 2 }}
                  >
                    Add Document
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#c896eb",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#8c1dd8",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Audit Trail</Typography>
                </Grid>

                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Revision Date</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Revised By</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Changes Made</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.revisionHistory.map((revision, index) => (
                        <TableRow key={index}>

                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              type="date"
                              value={revision.revisionDate.split("T")[0]}
                              onChange={(e) => handleRevisionChange(index, "revisionDate", e.target.value)}
                              //style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>
                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              //type="text"
                              value={revision.revisedBy}
                              onChange={(e) => handleRevisionChange(index, "revisedBy", e.target.value)}
                              //style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>
                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              //type="text"
                              value={revision.changesMade}
                              onChange={(e) => handleRevisionChange(index, "changesMade", e.target.value)}
                              style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>

                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                            <IconButton
                              onClick={() => handleRemoveRevision(index)}
                              color="error"
                            >
                              <RemoveCircleOutlineIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleAddRevision}
                    sx={{ mt: 2 }}
                  >
                    Add Revision
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Stack direction="row" spacing={2}
            justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              onActionComplete={riskRegisterFormClose}
            >
              {hierarchyData.find((item) => item.hierarchyTmpId === selectedHie && item.riskHierarchy != undefined && item.riskHierarchy != null && item.riskHierarchy?.riskAdditionalData != undefined && item.riskHierarchy?.riskAdditionalData != null) != undefined ? "UPDATE" : "SAVE"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RiskRegisterForm;